const HomeTop = () => {
    return ( 
        <div className="top-section">
        <h3 className="choose-title typing-text">Choose your new fwen...</h3>
        </div>
     );
}
 
export default HomeTop;